import React from "react";
import { Redirect, Route } from "react-router";
// import { getToken } from "./common";

//handling protected routes
function PrivateRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        // getToken() ? (
        sessionStorage.getItem("user") ? (
          <Component {...props} {...rest} />
        ) : (
          <Redirect to={{ pathname: "/", state: { from: props.location } }} />
        )
      }
    />
  );
}

export default PrivateRoute;
